import React, { FC } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {
  DAY_LABELS,
  DEFAULT_CLOSE_TIME,
  DEFAULT_OPEN_TIME,
  hhmmToIso,
  isoToHHMM,
} from 'utils/assist/assistMigrationHours';
import { AssistMigrationHours } from 'types/assist/assistMigration';

interface HoursOfOperationEditorProps {
  value: AssistMigrationHours[];
  onChange: (next: AssistMigrationHours[]) => void;
}

export const HoursOfOperationEditor: FC<HoursOfOperationEditorProps> = ({ value, onChange }) => {
  const byDay = new Map(value.map((entry) => [entry.day, entry]));

  const setDay = (day: number, patch: Partial<AssistMigrationHours> | null) => {
    const next: AssistMigrationHours[] = [];
    for (let d = 0; d < 7; d += 1) {
      if (d === day) {
        if (patch === null) {
          continue;
        }
        const existing = byDay.get(d) ?? {
          day: d,
          startTime: hhmmToIso(DEFAULT_OPEN_TIME),
          endTime: hhmmToIso(DEFAULT_CLOSE_TIME),
        };
        next.push({ ...existing, ...patch, day: d });
      } else if (byDay.has(d)) {
        next.push(byDay.get(d) as AssistMigrationHours);
      }
    }
    onChange(next);
  };

  return (
    <div>
      {DAY_LABELS.map((label, day) => {
        const entry = byDay.get(day);
        const open = !!entry;

        return (
          <div key={day} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <div style={{ display: 'flex', alignItems: 'center', width: 92 }}>
              <Checkbox
                size="small"
                checked={open}
                onChange={(event) => setDay(day, event.target.checked ? {} : null)}
              />
              <Typography variant="caption" style={{ fontWeight: 600 }}>
                {label}
              </Typography>
            </div>
            <TextField
              size="small"
              type="time"
              disabled={!open}
              value={entry ? isoToHHMM(entry.startTime) : ''}
              onChange={(event) => setDay(day, { startTime: hhmmToIso(event.target.value) })}
            />
            <Typography variant="caption">–</Typography>
            <TextField
              size="small"
              type="time"
              disabled={!open}
              value={entry ? isoToHHMM(entry.endTime) : ''}
              onChange={(event) => setDay(day, { endTime: hhmmToIso(event.target.value) })}
            />
          </div>
        );
      })}
    </div>
  );
};
